import { render, staticRenderFns } from "./screenfull.vue?vue&type=template&id=333d0d67&scoped=true"
import script from "./screenfull.vue?vue&type=script&lang=js"
export * from "./screenfull.vue?vue&type=script&lang=js"
import style0 from "./screenfull.vue?vue&type=style&index=0&id=333d0d67&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333d0d67",
  null
  
)

export default component.exports